import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bulma/css/bulma.min.css';
import './App.css';
import { Navbar } from './components/Navbar';
import { ScrollToTop } from './components/ScrollToTop';
import { Footer } from './components/Footer';
import { HomePage } from './pages/Home';
import { AboutPage } from './pages/About';
import { ServicesPage } from './pages/Services';
import { GamesPage } from './pages/Games';
import { NewsPage } from './pages/News';
import { ContactPage } from './pages/Contact';
import { PrivacyPage } from './pages/Privacy';
import { TermsPage } from './pages/Terms';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<><Navbar /><AboutPage /><Footer /></>} />
        <Route path="/services" element={<><Navbar /><ServicesPage /><Footer /></>} />
        <Route path="/games" element={<><Navbar /><GamesPage /><Footer /></>} />
        <Route path="/news" element={<><Navbar /><NewsPage /><Footer /></>} />
        <Route path="/contact" element={<><Navbar /><ContactPage /><Footer /></>} />
        <Route path="/privacy" element={<><Navbar /><PrivacyPage /><Footer /></>} />
        <Route path="/terms" element={<><Navbar /><TermsPage /><Footer /></>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
